<template>
  <div
      class="el-progress"
      :class="[
      'el-progress--' + type,
      status ? 'is-' + status : '',
      {
        'el-progress--without-text': status === '',
        'el-progress--text-inside': status === '',
      }
    ]"
      role="progressbar"
      :aria-valuenow="percentage"
      aria-valuemin="0"
      aria-valuemax="100"
  >
    <div class="el-progress-bar"
         v-if="type === 'line'">
      <div class="el-progress-bar__outer"
           :style="{height: strokeWidth + 'px'}">
        <div class="el-progress-bar__inner" v-for="(part, index) in barParts"
             :style="barStyle(part, index, barParts)">
          <div class="el-progress-bar__innerText"
               v-if="showText && textInside">{{part.width}}%
          </div>
        </div>
      </div>
    </div>
    <div class="el-progress__text" v-if="status">
      <i :class="iconClass"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SjProgress',
  data () {
    return {
      type: 'line',
    }
  },
  props: {
    percentages: {
      type: Array,
      default: []
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    barParts () {
      let result = []
      for (let i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result.push(this.percentages[i])
        }
      }
      return result
    },
    percentage () {
      let result = 0
      for (let i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result += this.percentages[i].width
        }
      }
      return result
    },
    iconClass () {
      switch (this.status) {
        case 'success':
          return 'el-icon-circle-check'
        case 'error':
        case 'exception':
          return 'el-icon-circle-close'
        case 'ongoing':
          return 'el-icon-loading'
      }
    },
  },
  methods: {
    getColor (status) {
      let ret
      switch (status) {
        case 'success':
          ret = '#13ce66'
          break
        case 'exception':
        case 'error':
          ret = '#f56c6c'
          break
        default:
          ret = '#20a0ff'
      }
      return ret
    },
    barStyle (part, index, parts) {
      let style = Object.assign({
        backgroundColor: part.status ? this.getColor(part.status) : part.color,
        borderRadius: 'none',
        display: 'inline-block',
        position: 'relative'
      }, part)

      style.width = part.width + '%'

      if (parts.length === 1) {
        style.borderRadius = '100px'
      }

      if (parts.length > 1 && index === 0) {
        style.borderRadius = '100px 0 0 100px'
      }

      if (parts.length > 1 && index + 1 === parts.length) {
        style.borderRadius = '0 100px 100px 0'
      }

      return style
    },
  }
}
</script>

<style lang="scss"
       scoped>
.el-progress.is-error .el-progress__text {
  color: #f56c6c
}
.el-progress-bar {
  padding-right: 30px;
  margin-right: -30px;
}
</style>



// WEBPACK FOOTER //
// src/components/sj-progress/SjProgress.vue